module.exports = __webpack_public_path__ + "static/media/smallOk.6e28f58d.png";